import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "../api";
import { useStore } from "../store";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setAdminToken } = useStore();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdminToken(data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Accesso non riuscito", { position: "top-center" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto px-6 py-16" data-testid="admin-login-page">
      <div className="flex items-center gap-3 -ml-2 mb-10">
        <button data-testid="back-button" onClick={() => navigate(-1)} aria-label="Torna indietro" className="p-2 text-[#2C2C2C] hover:opacity-60 transition-opacity duration-200">
          <ArrowLeft size={20} strokeWidth={1.5} />
        </button>
      </div>
      <div className="text-center mb-10">
        <img src="/brand/logo-content.png" alt="Dorae" className="h-14 object-contain mx-auto" />
        <h1 className="mt-6 font-display text-2xl text-[#2C2C2C]">Area riservata</h1>
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
        <input required type="email" data-testid="admin-email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white border border-[#EAE4DA] px-4 py-3 text-base outline-none focus:border-[#D4AF37] transition-colors" />
        <input required type="password" data-testid="admin-password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-[#EAE4DA] px-4 py-3 text-base outline-none focus:border-[#D4AF37] transition-colors" />
        <button type="submit" data-testid="admin-login-submit" disabled={loading} className="w-full gold-gradient text-white py-3.5 text-[12px] font-semibold tracking-wide-spaced uppercase hover:opacity-90 transition-opacity duration-300 disabled:opacity-50">
          {loading ? "Accesso..." : "Accedi"}
        </button>
      </form>
    </div>
  );
}
